import React from 'react';
import PropTypes from 'prop-types';

import application_contants from '../../contants/application_contants';
// Replace these with your actual icon imports or URLs:


export default function Challenge({ section_id }) {
  // card definitions
  // const cards = [
  //   {
  //     icon: application_contants.micicon ,
  //     title: 'Accent Transfer',
  //     text:  'Adapting speech models to understand and generate various regional or foreign accents accurately.'
  //   },
  //   {
  //     icon: application_contants.styleicon ,
  //     title: 'Style Transfer',
  //     text:  'Modifying the delivery style of speech (e.g., tone, speed, emotion) while preserving the content.'
  //   },
  //   {
  //     icon: application_contants.globalicon ,
  //     title: 'Low-resource Language Adaptation',
  //     text:  'Training models to perform well on languages with limited data or digital resources.'
  //   }
  // ]

  // example target languages
  const targets = [{ icon: application_contants.hindilang , label: 'Hindi' },
    { icon: application_contants.bengalilang , label: 'Bengali' },
    { icon: application_contants.marathilang , label: 'Marathi' },
    { icon: application_contants.telugulang , label: 'Telugu' },
    { icon: application_contants.bhojpurilang , label: 'Bhojpuri' },
    { icon: application_contants.kannadalang , label: 'Kannada' },
    { icon: application_contants.magadhilang , label: 'Magadhi' },
    { icon: application_contants.chhattisgarhilang , label: 'Chhattisgarhi' },
    { icon: application_contants.maithililang , label: 'Maithili' },
    { icon: application_contants.englishlang , label: 'English' },
    { icon: application_contants.gujaratilang , label: 'Gujarati' }
  ]
   const round1 = [
    { icon: application_contants.Zap, label: 'Must support multiple languages, especially those in SYSPIN 9 languages (Hindi, Bengali, Marathi, Telugu, Bhojpuri, Kannada, Magadhi, Chhattisgarhi, and Maithili), as well as languages of SPICOR TTS corpora, namely, English and Gujarati.' },
    { icon: application_contants.Zap, label: 'The system should be lightweight and efficient, meaning it should have low inference time, compact size (MB) for deployment on real time applications.' },
    { icon: application_contants.Zap, label: 'Deliver natural, high-quality audio synthesis for single sentences as well as longer text, such as paragraphs or pages, incorporating appropriate pauses and maintaining naturalness throughout.' },
    { icon: application_contants.Zap, label: 'Propose solutions that are innovative while also demonstrating practical real-world applicability.' },
    { icon: application_contants.Zap, label: 'In order to be considered for the prizes, a team must open source/share their model and any custom datasets used.' },
    { icon: application_contants.Zap, label: 'Participants are required to host their model as a REST API server, enabling users to send text and audio inputs as requests and receive generated audio responses.'}
  ]

  return (
    <section id={section_id} className="challenge-section">
      <div className="challenge-header">
        {/* <p className="challenge-subtitle title-navy-blue">Things you should know</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Problem Statement</h2>
        <p className="jostRegular h5-small section-title title-dark-grey about-text">
          Develop an advanced multi-speaker, multilingual text-to-speech (TTS) synthesizer that supports accent and style transfer, with a focus on efficiency, scalability, and quality. The winning model will be used in an LLM based assistant for pregnant to-be-mothers in low income communities.
        </p>
      </div>
    
      {/* <div className="challenge-cards">
        {cards.map(({ icon, title, text }) => (
          <div key={title} className="challenge-card">
            <div className="card-icon">
              <img src={icon} alt="" />
            </div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div> */}

      <div className="challenge-targets">
        <h3 className="targets-heading ">Target language</h3>
        <div className="targets-list">
          {targets.map(({ icon, label }) => (
            <div key={label} className="target-item">
              <img src={icon} alt={label} />
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
<br></br>
      <div className="participate-rounds">
        <div className="">
          <h3 className="h2-medium section-title title-navy-blue pb-2 about-title">Requirements</h3>
          {round1.map(item => (
            <div key={item.label} className="round-item">
              <img src={item.icon} alt="" />
              <span className="jostRegular h5-small section-title title-dark-grey about-readmore-text">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

Challenge.propTypes = {
  section_id: PropTypes.string.isRequired
}
